import { memo, useRef } from "react";
import { BzMasterAgGrid } from "../../../components";
import FilterModal from "./FilterModal";
import { Col, Container, Row } from "react-bootstrap";
import { MUTUAL_FUND_HOLDINGS_GRID_REF, setMutualFundHoldingGridRef } from "../../../utils/global_functions";
// const Holdings = ({ activeFilters, setActiveFilters, arrOptionChainColDefs, holdings, isShowmodal, setIsShowmodal, handleFiltersOnClick }) => {

const Holdings = ({ ExtendHolding, selectedValue, holdings, handleDelete, isMasterDetail, handleOnFilterApply, activeFilters, setActiveFilters, arrOptionChainColDefs, handleFiltersOnClick }) => {

    setMutualFundHoldingGridRef(useRef());
    

    
    return (
        <>

            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col className='d-flex justify-content-start'>
                        <div className='font-regular font-size3 color-subtext pe-4'>{holdings.length} funds found...</div>
                        {/* <div className='d-flex justify-content-start'>
                        <div className='d-flex align-items-center'>
                            <div className='font-regular font-size4 color-text d-flex justify-content-center align-items-center pe-2'>Filters: </div> 
                            <div className='filters-chips-wrap'>
                                {selectedValue.map((element, index) =>
                                    <BzChip key={index} className='filter-chip me-2 text-capitalize'>{element}<div onClick={() => handleDelete(element, index)}  className='icon-10 icon-close icon-dark ms-2'></div></BzChip>
                                )}
                            </div>
                        </div>
                    </div> */}
                    </Col>

                    {/* <Col className='d-flex justify-content-end'>
                    <div onClick={() => { setIsShowmodal(true); }} className='icon-16 icon-filter icon-dark'></div>
                </Col>  */}
                </Row>

                <Row className='g-0 py-3'>
                    <Col>
                        <BzMasterAgGrid ref={MUTUAL_FUND_HOLDINGS_GRID_REF}  gridDetailCellRenderer={ExtendHolding} style={{ height: "40vh", width: "100%" }}
                            isMasterDetail={isMasterDetail} rowHeight={70} detailRowAutoHeight={true} rowSelection={'multiple'} className='ag-theme-alpine'
                            arrColumnData={arrOptionChainColDefs} arrRowData={holdings} />
                    </Col>
                </Row>

                <FilterModal
                    activeFilters={activeFilters}
                    setActiveFilters={setActiveFilters}
                    handleFiltersOnClick={handleFiltersOnClick}
                    handleOnFilterApply={handleOnFilterApply}
                />
            </Container>

        </>
    );
};

export default memo(Holdings);